//const BASEURL = 'http://localhost:8000'
const BASEURL = 'https://www.api.megadumpsterbinrental.com'
//const BASEURL = 'https://www.mega-trash.naimdev.xyz'
export default BASEURL
